class PopupMessage {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('.popup-message').forEach(function (el) {
            el.addEventListener('click', function() {
                el.remove()
            }, true)
        });
    }
}

export default PopupMessage